import React, { useState } from "react";
import emailIcon from "../../assets/dasboard/email-icon.svg";
import { getColorCode } from "../../utils/utility-functions";
import { CreateNewUserModel } from "../model/component";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { LOCALE } from "../../utils/constants";

function SendToFriendButton({
  currentAssessmentAttemptData,
  userGUID,
  userData,
  CreateGuestUserConnect,
  isRomanticCompatibility,
  reportType,
  // Opt-in presentation API — every existing caller omits both, so
  // `variant` defaults to "icon" and renders byte-for-byte the same
  // circular icon-only button as before. "pill" is additive only.
  variant = "icon",
  label,
}) {
  const [openSendToFriend, setOpenSendToFriend] = useState(false);
  const [guestUserData, setGuestUserData] = useState([]);
  const [selectedAssessmentAttemptId, setSelectedAssessmentAttemptId] =
    useState("");
  const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
  const handleSendToFriend = (item) => {
    setOpenSendToFriend(true);
    setSelectedAssessmentId(item?.assessmentId);
    setSelectedAssessmentAttemptId(item?.assessmentAttemptId);
  };
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const currentPersonalityGroup = currentAssessmentAttemptData
    ? currentAssessmentAttemptData?.personality?.role
    : "";

  const personalityColorLight = getColorCode(
    currentPersonalityGroup && currentPersonalityGroup
  ).light;

  const isPill = variant === "pill";

  return (
    <div>
      <button
        onClick={() => {
          const data = {
            assessmentAttemptId:
              currentAssessmentAttemptData.assessmentAttemptId,
            assessmentId: currentAssessmentAttemptData.assessmentId,
          };
          handleSendToFriend(data);
        }}
        onMouseEnter={(e) =>
          (e.currentTarget.style.backgroundColor = personalityColorLight)
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
        className={
          isPill
            ? "inline-flex flex-shrink-0 items-center gap-1 sm:gap-2 min-h-[44px] px-1 sm:px-4 py-2.5 rounded-full bg-gray-100 border border-gray-200 text-gray-700 font-medium text-sm hover:bg-gray-200 transition-colors"
            : "aspect-square w-max bg-[#d9d9d9] rounded-full flex items-center justify-center"
        }
      >
        <img
          src={emailIcon}
          alt="Email Sharing"
          className={
            isPill
              ? "w-3.5 h-3.5 sm:w-5 sm:h-5 flex-shrink-0"
              : "w-[40px] h-auto hover:text-insightful-purple"
          }
        />
        {isPill && label && <span className="whitespace-nowrap">{label}</span>}
      </button>

      <CreateNewUserModel
        isOpen={openSendToFriend}
        setOpen={setOpenSendToFriend}
        parentId={userGUID}
        CreateGuestUserConnect={CreateGuestUserConnect}
        parentEmail={userData?.email}
        guestUserData={guestUserData}
        assessmentAttemptId={selectedAssessmentAttemptId}
        assessmentId={selectedAssessmentId}
        setGuestUserData={setGuestUserData}
        type={"send_to_friend"}
        t={t}
        currentLocale={currentLocale}
        id={currentAssessmentAttemptData?.id}
        reportType={reportType}
      />
    </div>
  );
}

export default SendToFriendButton;
